// common-player 插件入口
// npm install common-player + Vue.use(CommonPlayer)，自动加载 jessibuca.js 并完成所有初始化
// 导出名为 CommonPlayer（默认）和 CommonPlayerDiff（别名），二者功能相同

import PlayerComponent from "./src/components/JessibucaPlayer/index.vue";

let scriptLoaded = false;
let scriptPromise = null;

/**
 * 动态加载 jessibuca.js 脚本（页面只需调用一次）
 * @param {string} src - 脚本地址
 */
function loadScript(src) {
  if (scriptLoaded) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      scriptLoaded = true;
      resolve();
    };
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error("[common-player] jessibuca.js 加载失败，文件路径: " + src));
    };
    document.head.appendChild(script);
  });
  return scriptPromise;
}

/**
 * Vue 插件 install 方法
 * @param {Vue} Vue - Vue 构造函数
 * @param {Object} options - 配置项
 * @param {string} options.decoder - decoder.js 路径，默认 /js/Jessibuca/decoder.js
 * @param {string} options.jessibucaSrc - jessibuca.js 路径，默认 /js/Jessibuca/jessibuca.js
 */
const install = function (Vue, options = {}) {
  if (install.installed) return;
  install.installed = true;

  const decoderPath = options.decoder || "/js/Jessibuca/decoder.js";
  const jessibucaSrc = options.jessibucaSrc || "/js/Jessibuca/jessibuca.js";

  // 注入配置到 Vue 原型，供 CommonPlayer 组件内部使用
  Vue.prototype.$jessibucaConfig = { decoder: decoderPath };

  // 异步加载 jessibuca.js，完成后挂载 $player
  if (typeof window !== "undefined") {
    if (window.Jessibuca) {
      // 已经通过 <script> 标签或其他方式加载过
      Vue.prototype.$player = window.Jessibuca;
    } else {
      // 插件自动注入 <script> 加载
      loadScript(jessibucaSrc)
        .then(() => {
          Vue.prototype.$player = window.Jessibuca;
        })
        .catch(err => {
          console.error(err);
        });
    }
  }

  // 注册全局组件
  Vue.component(PlayerComponent.name, PlayerComponent);
};

// 浏览器环境直接引入时自动安装
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

// 导出具名的插件对象，两个名字功能完全相同
const CommonPlayer = { install };
const CommonPlayerDiff = { install };

export default CommonPlayer;
export { CommonPlayer, CommonPlayerDiff, PlayerComponent };
